export let defaultScheduleSizeInDays = 7;

